export default {
  content: `<p>
    一套国家级/企业级超大规模 AI 算力集群集成机柜（或超高密度算力一体机），专为千亿至万亿参数级国产大模型的全量基座训练、超大规模多模态数据并行处理以及国家级信创算力中心的骨干节点建设而设计。
</p>
<p>
    系统打破了传统单机八卡的限制，在单一机柜或系统内高密度集成 32 张昇腾系列高端加速卡，通过独有的柜内高速总线实现无损全互联（类似于昇腾版的 NVSwitch/NVLink 簇），将 32 颗算力核心融合成一个超大、低延迟的统一计算池；辅以 8TB 的庞大系统内存与 64TB 高速缓存盘，能够轻松吞吐 PB 级别的训练数据集。为了支撑如此恐怖的单柜算力密度并彻底解决传统风冷散热的功耗瓶颈，系统原生采用工业级液冷设计，确保核心架构在极端高负载下依然保持绝佳的能效比与高稳定性，配合 4×100G/200G RoCE 无损网络，使其成为承载国家“东数西算”战略、大型科研院所及行业头部巨头构建国产化万卡算力集群的核心基础单元。
</p>`,
  country: "中国",
  country_desc:
    "靠近太平洋海底光缆登陆点，是连接亚太地区网络延迟最低的区域，非常适合面向亚洲用户",
};
